import styled from "@emotion/styled";

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  height: 80px;
  box-sizing: border-box;
  align-items: center;
`;

export const Container = styled.div`
  padding: 0 20px 80px 20px;
  flex: 1;
  min-width: 1140px;
`;

export const BtnContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const TabContainer = styled.div`
  margin-top: 8px;
  height: 40px;
  box-sizing: border-box;
  padding: 0 24px;
  align-items: center;
  display: flex;
  gap: 20px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const TabItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => props.selected && "border-bottom: 2px solid var(--alias-color-primary-normal);"}
  box-sizing: border-box;
  height: 40px;
  padding: 8px 12px;
  align-content: center;
  cursor: pointer;
`;

export const CancelBtnContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;

export const TitleHeader = styled.div`
  display: flex;

  padding: 0px 0px 16px 8px;

  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  .title {
    display: flex;
    gap: 6px;
    align-items: flex-end;
    width: 100%;
  }

  .annotation {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
